import { render, staticRenderFns } from "./CounselingChat.vue?vue&type=template&id=e3470614&scoped=true"
import script from "./CounselingChat.vue?vue&type=script&lang=js"
export * from "./CounselingChat.vue?vue&type=script&lang=js"
import style0 from "./CounselingChat.vue?vue&type=style&index=0&id=e3470614&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3470614",
  null
  
)

export default component.exports